/** Track 1: the guided first hour. Order = the order the guide teaches the game in. */
export const ONBOARDING_STEPS = [
  'homeViewed',     // look at the home system
  'scoutLaunched',  // explore: send a scout
  'firstSurvey',    // the scout surveys a system
  'depositFound',   // a surveyed system holds a deposit
  'outpostBuilt',   // claim a system with an outpost
  'firstUpgrade',   // build a mine / power station
  'productionSeen', // look at what the station produces
  'energySeen',     // learn the energy balance
  'civTrace',       // another civilization shows up on the map
  'goalChosen',     // pick a long-term goal
] as const;
export type OnboardingStep = typeof ONBOARDING_STEPS[number];

export const ONBOARDING_GOALS = ['expand', 'economy', 'research', 'diplomacy'] as const;
export type OnboardingGoal = typeof ONBOARDING_GOALS[number];

export interface OnboardingStateDto {
  steps: Array<{ id: OnboardingStep; done: boolean }>;
  /** First step that is not done yet (null when everything is). */
  next: OnboardingStep | null;
  completed: boolean;
  dismissed: boolean;
  autoOpen: boolean;
  goal: OnboardingGoal | null;
}
